import formInputMixin from './formInputMixin'
import ErrorHelpBlock from '../components/application/ErrorHelpBlock.vue'
import applicationFormContextMixin from './applicationFormContextMixin'
import typeaheadMixin from '../mixins/typeaheadMixin'

export default {
  mixins: [
    formInputMixin,
    typeaheadMixin,
    applicationFormContextMixin
  ],

  components: {
    ErrorHelpBlock
  },

  data: () => ({
    clearErrorOnFill: false,
    disableErrorBorder: false
  }),

  props: {
    hasErrors: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    selectTypeahead: {
      default () {
        return async (item) => {
          if (!item[this.typeaheadItemKey]) {
            return
          }

          this.inputValue = item[this.typeaheadItemKey]
        }
      }
    }
  },

  computed: {
    hasEmptyFieldError () {
      return Boolean(this.hasInputErrors)
    },

    actualErrorMessage () {
      if (this.disableErrorBorder) {
        return null
      }

      return this.inputError
    },

    formGroupClass () {
      const classes = ['form-group']

      if (this.hasInputErrors && !this.disableErrorBorder) {
        classes.push('has-error')
      }

      return classes
    }
  },

  watch: {
    inputValue () {
      this.clearErrorOnFill = this.hasEmptyFieldError
      this.disableErrorBorder = !!(this.clearErrorOnFill && this.inputValue)
    },

    errors () {
      this.disableErrorBorder = false
    }
  }
}
